module.exports = __webpack_public_path__ + "img/triangle.7a3d2427.svg";